import { useState } from 'react';

export interface UseComingSoonModalOptions {
  title?: string;
  subtitle?: string;
  message?: string;
  showAnimation?: boolean;
  animationSource?: any;
  closeOnBackdrop?: boolean;
  showCloseButton?: boolean;
}

export interface ComingSoonModalState {
  visible: boolean;
  title?: string;
  subtitle?: string;
  message?: string;
  showAnimation?: boolean;
  animationSource?: any;
  closeOnBackdrop?: boolean;
  showCloseButton?: boolean;
}

export const useComingSoonModal = (defaultOptions?: UseComingSoonModalOptions) => {
  const [modalState, setModalState] = useState<ComingSoonModalState>({
    visible: false,
    title: defaultOptions?.title,
    subtitle: defaultOptions?.subtitle,
    message: defaultOptions?.message,
    showAnimation: defaultOptions?.showAnimation ?? true,
    animationSource: defaultOptions?.animationSource,
    closeOnBackdrop: defaultOptions?.closeOnBackdrop ?? true,
    showCloseButton: defaultOptions?.showCloseButton ?? true,
  });

  const showModal = (options?: UseComingSoonModalOptions) => {
    setModalState(prevState => ({
      ...prevState,
      visible: true,
      ...options,
    }));
  };

  const hideModal = () => {
    setModalState(prevState => ({
      ...prevState,
      visible: false,
    }));
  };

  const updateModal = (options: Partial<UseComingSoonModalOptions>) => {
    setModalState(prevState => ({
      ...prevState,
      ...options,
    }));
  };

  return {
    modalState,
    showModal,
    hideModal,
    updateModal,
    isVisible: modalState.visible,
  };
};
